import {inject, singleton} from "tsyringe";
import {CommandHandler} from "../../decorators/command-handler.decorator";
import {KnowledgeObject} from "../../domain/entities/knowledge-object.entity";
import {MessageBroker} from "../../message-broker/message-broker";
import {EntityDeletedPayload} from "../../message-broker/payloads/entity-deleted.payload";
import {CommandBus} from "../../services/command-bus.service";
import {DeleteKnowledgeObjectCommand} from "../delete-knowledge-object.command";
import {ICommand} from "../i-command.interface";
import {ICommandHandler} from "./i-command.handler";

@CommandHandler(DeleteKnowledgeObjectCommand)
@singleton()
export class DeleteKnowledgeObjectCommandHandler implements ICommandHandler<KnowledgeObject> {

    constructor(
        @inject(CommandBus) private readonly _commandBus: CommandBus,
        @inject(MessageBroker) private readonly _messageBroker: MessageBroker
    ) {
    }

    public async handle(command: ICommand<KnowledgeObject>): Promise<void> {
        if (!(await this._commandBus.addSendCommand(command))) {
            return;
        }

        // The command already carries the full entity as its payload; no re-fetch.
        // Publishing the INSTANCE matters: EntityLiveRefreshController filters
        // deleted events on `payload.entity.constructor`.
        const entity = command.payload;
        if (!entity) {
            console.error(`Es wurde kein KnowledgeObject mit der UUID ${command.mainEntityUid} in der Persistenz gefunden.`);
            return;
        }

        this._messageBroker.publish<EntityDeletedPayload<KnowledgeObject>>({
            type: `entity.deleted`,
            identityHash: command.mainEntityUid,
            payload: {entity}
        });
    }
}
